<template>
  <div
    class="pageloader has-text-centered"
    v-bind:class="{'is-active':this.isLoading}"
  >
    <span style="position:absolute; top:300px;" class="title">{{ $t("loading.patienter") }}</span>
  </div>
</template>

<script>
export default {
  props: ['isLoading']
}
</script>
<style scoped>
.pageloader {
  background-color: #424a60 !important;
}
.pageloader::after {
    position: absolute;
    top: 400px;
    left: 50%;
    display: block;
    border-radius: 100%;
    content: '';
    z-index: 9999;
    -webkit-transform: translate(-50%,-50%);
    transform: translate(-50%,-50%);
    width: 0;
    height: 0;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    border: 0 solid #fff;
    -webkit-animation: loader-figure 1.15s infinite cubic-bezier(.215,.61,.355,1);
    animation: loader-figure 1.15s infinite cubic-bezier(.215,.61,.355,1);
}
</style>



// WEBPACK FOOTER //
// src/components/layout/Loader.vue